import { RETRIEVE_LOAD_USER_INFO, SELL_AVATAR, UPDATE_USER_RECORDS } from "../actions/types";

const INITIAL_STATE = {
  // payment info
  hanziMembershipExpire: new Date(),
  mathMembershipExpire: new Date(),
  adsFreeExpire: new Date(),
  // user records
  gainedAvatars: { // idOfAvatar: number of the avatar gained
    lion1: '1', 
    monkey1: '1', 
    monkey2: '1', 
    monkey3: '2'
  }, 
  coins: 0, // can be obtained by sell items user obtained, complete tests, can be used to buy items
  keys: 0, // 1 key = 1000 stars, used for other types of activities. for example rotate a wheel
  experience: 0, // same as coins, the difference is that coins can be spend experience cannot.
  hanziWriting: {},
  hanziQuiz: {},
  mathExercise: {},
  createdAt: new Date(),
}

const userRecordsReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case UPDATE_USER_RECORDS:
      return action.payload;

    case SELL_AVATAR:
      // will be done by http request instead of here, that way will be a safer way to do it.
      const avatarId = action.payload.avatarId;
      const copiesToSell = action.payload.copies ? action.payload.copies: 0;
      const unitPrice = action.payload.unitPrice ? action.payload.unitPrice: 0;
      const coins = state.coins + copiesToSell*unitPrice;
      const newGainedAvatars = {
        ...state.gainedAvatars,
      };
      newGainedAvatars[avatarId] = newGainedAvatars[avatarId] - action.payload.copies;

      return { 
        ...state,
        coins: coins,
        gainedAvatars: newGainedAvatars
      };

    case RETRIEVE_LOAD_USER_INFO:
    // case XYZ: other actions return data from DB are most likely go through the same logic
      // data is retrieved from database already, now extract data out and setup into the store
      // only load user settings if the status ode is 200.
      if (action.payload.status === 200) {
        const data = action.payload.data;
        // user payment info
        const hanziMembershipExpire = data.hanziMembershipExpire;
        const mathMembershipExpire = data.mathMembershipExpire;
        const adsFreeExpire = data.adsFreeExpire;
        // user records
        const gainedAvatars = data.gainedAvatars;
        const coins = data.coins;
        const keys = data.keys;
        const experience = data.experience;
        const hanziWriting = data.hanziWriting;
        const hanziQuiz = data.hanziQuiz;
        const mathExercise = data.mathExercise;
        const createdAt = data.createdAt;

        return {
          hanziMembershipExpire,
          mathMembershipExpire,
          adsFreeExpire,
          gainedAvatars,
          coins,
          keys,
          experience,
          hanziWriting,
          hanziQuiz,
          mathExercise,
          createdAt
        };
      };
      // if the status code is not 200, do not update this redux store
      return state;
    default: 
      return state;
  }
}

export default userRecordsReducer;